import { render, staticRenderFns } from "./ListaClientes.vue?vue&type=template&id=3c023080&scoped=true&"
import script from "./ListaClientes.vue?vue&type=script&lang=js&"
export * from "./ListaClientes.vue?vue&type=script&lang=js&"
import style0 from "./ListaClientes.vue?vue&type=style&index=0&id=3c023080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c023080",
  null
  
)

export default component.exports